import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {fadeIn, fadeOut} from '../../../../animations';
import {ToastService} from '../../../../services/ui/toast.service';
import {BinderSessionWizardService} from '../../../../services/sections/binder/binder-session-wizard.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import {ToastType} from '../../../toast/models/toast-type.enum';
import {Toast} from '../../../toast/models/toast.model';

@Component({
  selector: 'binder-session-code',
  templateUrl: './binder-session-code.component.html',
  styleUrls: ['./binder-session-code.component.scss', '../../../stylesheets/job-main.scss'],
  animations: [fadeIn(200), fadeOut(200)]
})
export class BinderSessionCodeComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
        GlobalSettingsService.isGlobalLoaderLoading = false;
        GlobalSettingsService.isSecondaryLoaderLoading = false;
    }
}
